import { render, staticRenderFns } from "./GlobalDialogs.vue?vue&type=template&id=e6e5f3c4&"
import script from "./GlobalDialogs.vue?vue&type=script&lang=js&"
export * from "./GlobalDialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports